<template>
	<div id="app">
    <router-view></router-view>
		<!-- <keep-alive>
			<router-view v-if="$route.meta.isAlive"></router-view>
		</keep-alive>
		<router-view v-if="!$route.meta.isAlive"></router-view> -->
	</div>
</template>

<script>
export default {
	name: 'App',
  computed: {
    key() {
      return this.$route.fullPath
    }
  }
}
</script>

<style>
@import "../static/css/main.css";
@import "../static/css/color-dark.css";
@import "../static/css/elstyle.css";

#app {
	font-family: 'Avenir', Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	/*text-align: center;*/
	color: #2c3e50;
	/*margin-top: 60px;*/
}
</style>



// WEBPACK FOOTER //
// src/App.vue